import WOW from 'wowjs'
window.wow = new WOW.WOW({
    live: false
});
window.wow.init();



